export const sportsDataStatRequiredQuery = {
	bool: {
		must: [
			{
				exists: {
					field: 'sportsData.stat',
				},
			},
		],
	},
};
